import { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import SectionTag from '../components/SectionTag';
import { MARKETS } from '../content/siteContent';

export default function Markets() {
  const [active, setActive] = useState(-1);

  return (
    <section
      id="markets"
      data-testid="markets-section"
      className="relative overflow-hidden bg-[#000000] py-28 md:py-40"
    >
      {/* Hover-driven background imagery */}
      <div className="pointer-events-none absolute inset-0 hidden md:block" aria-hidden="true">
        {MARKETS.map((m, i) => (
          <img
            key={m.name}
            src={m.image}
            alt=""
            loading="lazy"
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover transition-[opacity,transform] duration-700 ease-out"
            style={{ opacity: active === i ? 0.35 : 0, transform: active === i ? 'scale(1)' : 'scale(1.08)' }}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />
      </div>

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-12">
        <SectionTag number="08" label="Markets & Industries" />
        <h2 className="mt-10 max-w-3xl font-display text-2xl font-semibold tracking-tight text-white md:text-4xl">
          Where energy moves
        </h2>

        <ul className="mt-16 border-t border-white/10 md:mt-24">
          {MARKETS.map((m, i) => (
            <li key={m.name}>
              <button
                data-testid={`market-row-${i}`}
                data-cursor="EXPLORE"
                onMouseEnter={() => setActive(i)}
                onMouseLeave={() => setActive(-1)}
                onFocus={() => setActive(i)}
                onBlur={() => setActive(-1)}
                className="group flex w-full items-center justify-between gap-6 border-b border-white/10 py-7 text-left transition-[padding] duration-500 ease-out hover:pl-4 md:py-10 md:hover:pl-8"
              >
                <span className="flex items-baseline gap-5 md:gap-10">
                  <span className="font-display text-xs font-medium tracking-[0.3em] text-[#47a0d9]">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span
                    className={`font-display text-2xl font-semibold tracking-tight transition-colors duration-500 md:text-4xl ${
                      active === i ? 'text-white' : 'text-white/55'
                    }`}
                  >
                    {m.name}
                  </span>
                </span>
                <span className="flex items-center gap-6">
                  <span className="hidden text-[10px] uppercase tracking-[0.22em] text-white/35 md:block">
                    {m.note}
                  </span>
                  <ArrowRight
                    size={22}
                    className={`shrink-0 transition-[transform,color] duration-500 ${
                      active === i ? 'translate-x-0 text-[#47a0d9]' : '-translate-x-3 text-white/30'
                    }`}
                  />
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
